"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEnum = exports.getKeys = exports.getEnumValue = exports.checkAllPropertiesExist = void 0;
const _ = __importStar(require("lodash"));
const error_1 = require("../error");
// util method for confirming that all properties exist in the given typeguard
// will error log with the specific missing property when it's caught
const checkAllPropertiesExist = ({ obj, properties, forType, metadata, }) => {
    const loggerMetadata = metadata ? { ...metadata } : {};
    if (!obj) {
        throw new Error(`Object does not exist for type ${forType} ${loggerMetadata}`);
        // logger.error(`Object does not exist for type ${forType}`, {
        //   ...loggerMetadata,
        // });
    }
    return (obj &&
        _.every(properties, (property) => {
            const propExists = property in obj;
            if (!propExists) {
                return false;
                // NOTE:
                // We're returning false here, since logger cannot be tightly coupled here.
                // For the future iteration, we may want to inject logger (w/ common interface), and
                // log error and move on here.  Throwing exception is an another approach, but caller
                // will have to be mindful and for typeguard, it might not be the best behavior.
                //
                // logger.error(
                //   `Property \`${property}\` does not exist in object for type ${forType}`,
                //   {
                //     ...loggerMetadata,
                //   },
                // );
            }
            return propExists;
        }));
};
exports.checkAllPropertiesExist = checkAllPropertiesExist;
/**
 * Typeguard to assert value is a valid enum value. Strongly prefer {@link toEnum()}
 * where possible, since it provides better compile-time type safety.
 */
const getEnumValue = (enumType, value) => {
    const validEnumValue = _.includes(_.values(enumType), value);
    (0, error_1.finleyAssert)(validEnumValue, new error_1.TypeError({
        resourceType: 'enum',
        typeguardName: 'getEnumValue',
        metadata: { logMeta: { enumType, value } },
    }));
    return value;
};
exports.getEnumValue = getEnumValue;
/**
 * Checks at compile time that a string union type can safetly be assigned to an enum type.
 */
const toEnum = (from) => {
    // This is safe because `from` is a subtype of StringUnion<EnumT>.
    return from;
};
exports.toEnum = toEnum;
/**
 * gets typed keys of an object (instead of defaulting to string[])
 */
const getKeys = Object.keys;
exports.getKeys = getKeys;
//# sourceMappingURL=utils.js.map